// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-statistics-teams__container {
    background-color: var(--white-color);
    padding: var(--space-and-half);
    border-radius: var(--space-half);
    height: 430px;
    position: relative;
}

.tournament-statistics-teams__title {
    display: flex;
    justify-content: space-between;
}

.tournament-statistics-teams__row {
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-right: 24px;
}

.tournament-statistics-teams__row__counter.baloa-normal-medium {
    color: var(--basic-gray-color);
    margin-right: 16px;
}

.tournament-statistics-teams__row__goals.baloa-normal-medium {
    color: var(--primary-very-dark-color);
    margin-left: auto;
}

.tournament-statistics-teams__no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 140px;
}

.tournament-statistics-teams__no-data .baloa-normal {
    color: var(--primary-dark-color);
}

.tournament-statistics-teams__next-button {
    position: absolute;
    bottom: 0;
    padding: 12px;
    text-align: center;
    width: calc(100% - 24px);
    cursor: pointer;
}

.tournament-statistics-teams__next-button.baloa-names {
    color: var(--new-green-color);
}

.tournament-statistics-teams__container .baloa-names.infolbl {
    color: var(--primary-very-dark-color);
    font-weight: var(--font-regular);
    margin-top: 24px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.tournament-statistics-teams__container .baloa-names.infolbl .hubicon-info_v2 {
    color: var(--new-informative-banner-color);
    font-size: 22px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .tournament-statistics-teams__container{
        margin: 12px;
        height: 320px;
    }

    .tournament-statistics-teams__container .tournament-player-info__container img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
    }

    .tournament-statistics-teams__container .tournament-player-info__container .icon-ball {
        font-size: 22px;
        padding: 3px;
    }

}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-statistics-teams/TournamentStatisticsTeamsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,8BAA8B;IAC9B,gCAAgC;IAChC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,qCAAqC;IACrC,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,0CAA0C;IAC1C,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;AAEJ","sourcesContent":[".tournament-statistics-teams__container {\n    background-color: var(--white-color);\n    padding: var(--space-and-half);\n    border-radius: var(--space-half);\n    height: 430px;\n    position: relative;\n}\n\n.tournament-statistics-teams__title {\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-statistics-teams__row {\n    display: flex;\n    align-items: center;\n    margin-top: 16px;\n    margin-right: 24px;\n}\n\n.tournament-statistics-teams__row__counter.baloa-normal-medium {\n    color: var(--basic-gray-color);\n    margin-right: 16px;\n}\n\n.tournament-statistics-teams__row__goals.baloa-normal-medium {\n    color: var(--primary-very-dark-color);\n    margin-left: auto;\n}\n\n.tournament-statistics-teams__no-data {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 140px;\n}\n\n.tournament-statistics-teams__no-data .baloa-normal {\n    color: var(--primary-dark-color);\n}\n\n.tournament-statistics-teams__next-button {\n    position: absolute;\n    bottom: 0;\n    padding: 12px;\n    text-align: center;\n    width: calc(100% - 24px);\n    cursor: pointer;\n}\n\n.tournament-statistics-teams__next-button.baloa-names {\n    color: var(--new-green-color);\n}\n\n.tournament-statistics-teams__container .baloa-names.infolbl {\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-regular);\n    margin-top: 24px;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.tournament-statistics-teams__container .baloa-names.infolbl .hubicon-info_v2 {\n    color: var(--new-informative-banner-color);\n    font-size: 22px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .tournament-statistics-teams__container{\n        margin: 12px;\n        height: 320px;\n    }\n\n    .tournament-statistics-teams__container .tournament-player-info__container img {\n        width: 28px;\n        height: 28px;\n        border-radius: 50%;\n    }\n\n    .tournament-statistics-teams__container .tournament-player-info__container .icon-ball {\n        font-size: 22px;\n        padding: 3px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
